import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataDeductionTypeDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataDeductionTypeUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataDeductionTypeDTO) {
    return this.repository.createDeductionType(params);
  }
}
